import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterCheckbox',
  props: {
  modelValue: {
    type: Boolean,
  }
},
  emits: ["update:modelValue"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass([__props.modelValue ? 'filter-checkbox__checked' : '', "filter-checkbox"]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !__props.modelValue)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}
}

})